<template>
	<v-select :value="selectedTemplateId" @input="(e) => $emit('onSelectedTemplate', e)" :items="templates.map((t) => t.id)" outlined>
		<template v-slot:selection="{ item }">
			<CardDisplay
				class="card-displayer"
				:cardData="{ fields: {} }"
				:cardTemplate="templates.find((t) => t.id === item)"
				:isTemplateMode="true"
			/>
		</template>
		<template v-slot:item="{ item }">
			<CardDisplay
				class="card-displayer"
				:cardData="{ fields: {} }"
				:cardTemplate="templates.find((t) => t.id === item)"
				:isTemplateMode="true"
			/>
		</template>
	</v-select>
</template>

<script>
import CardDisplay from '../../WidgetFields/CardsField/CardDisplay';

export default {
	name: 'TemplateSelector',
	components: {
		CardDisplay,
	},
	props: {
		templates: { type: Array },
		selectedTemplateId: { type: Number },
	},
};
</script>

<style scoped lang="scss">
.card-displayer {
	padding: 20px;
	width: 100%;

	::v-deep {
		.card-cell {
			// height is constant so that it works with a title for the cell
			height: auto !important;
		}
		.dummy-filler > div {
			background-color: #bebebf;
		}
	}
}

::v-deep .v-input__slot {
	min-height: 100px !important;

	fieldset {
		border-color: #ced0da;
		background-color: #f5f8fe;
	}
}
</style>
